var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "buytix" } }, [
    !_vm.orderComplete
      ? _c(
          "div",
          {
            staticClass: "columns modalcolumns",
            attrs: { id: "modalcolumns" }
          },
          [
            _c(
              "div",
              { staticClass: "column mobilepad", attrs: { id: "ticketleft" } },
              [
                !_vm.checkout
                  ? _c(
                      "div",
                      {
                        staticClass: "modal-content-wrap",
                        class: { "is-hidden-mobile": _vm.cart }
                      },
                      [
                        _c("EventPreview", {
                          attrs: {
                            event: _vm.event,
                            selectedDate: _vm.selectedDate,
                            venue: _vm.venue
                          }
                        }),
                        _vm.eventDates.length > 1 &&
                        (!_vm.event.eventType ||
                          _vm.event.eventType != "videoOnDemand")
                          ? _c("DateSlider", {
                              attrs: {
                                dates: _vm.eventDates,
                                visible: _vm.visible
                              },
                              on: { setDate: _vm.setDate }
                            })
                          : _vm._e(),
                        _vm.selectedDate
                          ? _c(
                              "div",
                              { staticClass: "price-tiers mobilepad" },
                              [
                                _vm._l(_vm.priceTiers, function(tier) {
                                  return _c(
                                    "div",
                                    { key: tier.id, staticClass: "pricetier" },
                                    [
                                      !tier.selectDates ||
                                      (tier.selectDates &&
                                        tier.selectedDates.indexOf(
                                          _vm.selectedDate.id
                                        ) > -1)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "columns is-mobile"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "column" },
                                                [
                                                  _c("h4", [
                                                    _vm._v(_vm._s(tier.name))
                                                  ]),
                                                  tier.description
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "tier-description"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                tier.description
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  tier.feeType == "fixed"
                                                    ? _c("p", [
                                                        _vm._v(
                                                          "$" +
                                                            _vm._s(tier.price)
                                                        )
                                                      ])
                                                    : _vm._e(),
                                                  tier.feeType == "free"
                                                    ? _c("p", [_vm._v("Free!")])
                                                    : _vm._e(),
                                                  tier.feeType == "sliding"
                                                    ? _c("div", [
                                                        _c("div", [
                                                          _c("span", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "$" +
                                                                  _vm._s(
                                                                    tier.price
                                                                  ) +
                                                                  " per ticket"
                                                              )
                                                            ])
                                                          ])
                                                        ]),
                                                        _c("div", [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model.number",
                                                                value:
                                                                  tier.price,
                                                                expression:
                                                                  "tier.price",
                                                                modifiers: {
                                                                  number: true
                                                                }
                                                              }
                                                            ],
                                                            staticClass:
                                                              "slider is-fullwidth is-success",
                                                            attrs: {
                                                              step: "1",
                                                              min:
                                                                tier.minPrice,
                                                              max:
                                                                tier.maxPrice,
                                                              type: "range"
                                                            },
                                                            domProps: {
                                                              value: tier.price
                                                            },
                                                            on: {
                                                              __r: function(
                                                                $event
                                                              ) {
                                                                _vm.$set(
                                                                  tier,
                                                                  "price",
                                                                  _vm._n(
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                )
                                                              },
                                                              blur: function(
                                                                $event
                                                              ) {
                                                                return _vm.$forceUpdate()
                                                              }
                                                            }
                                                          })
                                                        ]),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "level is-mobile"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "level-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "$" +
                                                                    _vm._s(
                                                                      tier.minPrice
                                                                    )
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "level-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "$" +
                                                                    _vm._s(
                                                                      tier.maxPrice
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "column is-narrow quantity"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "select" },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.number",
                                                              value:
                                                                tier.quantity,
                                                              expression:
                                                                "tier.quantity",
                                                              modifiers: {
                                                                number: true
                                                              }
                                                            }
                                                          ],
                                                          on: {
                                                            change: function(
                                                              $event
                                                            ) {
                                                              var $$selectedVal = Array.prototype.filter
                                                                .call(
                                                                  $event.target
                                                                    .options,
                                                                  function(o) {
                                                                    return o.selected
                                                                  }
                                                                )
                                                                .map(function(
                                                                  o
                                                                ) {
                                                                  var val =
                                                                    "_value" in
                                                                    o
                                                                      ? o._value
                                                                      : o.value
                                                                  return _vm._n(
                                                                    val
                                                                  )
                                                                })
                                                              _vm.$set(
                                                                tier,
                                                                "quantity",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "option",
                                                            {
                                                              attrs: {
                                                                value: "0"
                                                              }
                                                            },
                                                            [_vm._v("0")]
                                                          ),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 1
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "1"
                                                                  }
                                                                },
                                                                [_vm._v(" 1 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 2
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "2"
                                                                  }
                                                                },
                                                                [_vm._v(" 2 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 3
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "3"
                                                                  }
                                                                },
                                                                [_vm._v(" 3 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 4
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "4"
                                                                  }
                                                                },
                                                                [_vm._v(" 4 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 5
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "5"
                                                                  }
                                                                },
                                                                [_vm._v(" 5 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 6
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "6"
                                                                  }
                                                                },
                                                                [_vm._v(" 6 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 7
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "7"
                                                                  }
                                                                },
                                                                [_vm._v(" 7 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 8
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "8"
                                                                  }
                                                                },
                                                                [_vm._v(" 8 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 9
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "9"
                                                                  }
                                                                },
                                                                [_vm._v(" 9 ")]
                                                              )
                                                            : _vm._e(),
                                                          !_vm.selectedDate
                                                            .maxSale ||
                                                          _vm.selectedDate
                                                            .maxSale >= 10
                                                            ? _c(
                                                                "option",
                                                                {
                                                                  attrs: {
                                                                    value: "10"
                                                                  }
                                                                },
                                                                [_vm._v(" 10 ")]
                                                              )
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                _vm.event.donation
                                  ? _c(
                                      "div",
                                      { staticClass: "donatio pricetier" },
                                      [
                                        !_vm.event.donationDetails ||
                                        !_vm.event.donationDetails.name
                                          ? _c("h4", [
                                              _vm._v(" Artist Donation ")
                                            ])
                                          : _vm._e(),
                                        _vm.event.donationDetails &&
                                        _vm.event.donationDetails.name
                                          ? _c("h4", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.event.donationDetails
                                                      .name
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e(),
                                        !_vm.event.donationDetails ||
                                        !_vm.event.donationDetails.description
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "tier-description"
                                              },
                                              [
                                                _vm._v(
                                                  " Add a tip for the artist "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.event.donationDetails &&
                                        _vm.event.donationDetails.description
                                          ? _c(
                                              "p",
                                              {
                                                staticClass: "tier-description"
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.event.donationDetails
                                                        .description
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        !_vm.event.donationDetails ||
                                        _vm.event.donationDetails.type !=
                                          "sliding"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "control donations"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "field" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: _vm.donation,
                                                          expression:
                                                            "donation",
                                                          modifiers: {
                                                            number: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "is-checkradio",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "donationfive",
                                                        name: "donation",
                                                        value: "5"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.donation,
                                                          _vm._n("5")
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.donation = _vm._n(
                                                            "5"
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "donationfive"
                                                        }
                                                      },
                                                      [_vm._v("$5")]
                                                    ),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: _vm.donation,
                                                          expression:
                                                            "donation",
                                                          modifiers: {
                                                            number: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "is-checkradio",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "donationten",
                                                        name: "donation",
                                                        value: "10"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.donation,
                                                          _vm._n("10")
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.donation = _vm._n(
                                                            "10"
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "donationten"
                                                        }
                                                      },
                                                      [_vm._v("$10")]
                                                    ),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: _vm.donation,
                                                          expression:
                                                            "donation",
                                                          modifiers: {
                                                            number: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "is-checkradio",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "donationfifteen",
                                                        name: "donation",
                                                        value: "15"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.donation,
                                                          _vm._n("15")
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.donation = _vm._n(
                                                            "15"
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "donationfifteen"
                                                        }
                                                      },
                                                      [_vm._v("$15")]
                                                    ),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: _vm.donation,
                                                          expression:
                                                            "donation",
                                                          modifiers: {
                                                            number: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "is-checkradio",
                                                      attrs: {
                                                        type: "radio",
                                                        id: "donationtwenty",
                                                        name: "donation",
                                                        value: "20"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.donation,
                                                          _vm._n("20")
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.donation = _vm._n(
                                                            "20"
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "donationtwenty"
                                                        }
                                                      },
                                                      [_vm._v("$20")]
                                                    ),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: _vm.donation,
                                                          expression:
                                                            "donation",
                                                          modifiers: {
                                                            number: true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "is-checkradio",
                                                      attrs: {
                                                        type: "radio",
                                                        id:
                                                          "donationtwentyfive",
                                                        name: "donation",
                                                        value: "25"
                                                      },
                                                      domProps: {
                                                        checked: _vm._q(
                                                          _vm.donation,
                                                          _vm._n("25")
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.donation = _vm._n(
                                                            "25"
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "donationtwentyfive"
                                                        }
                                                      },
                                                      [_vm._v("$25")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.event.donationDetails &&
                                        _vm.event.donationDetails.type ==
                                          "sliding"
                                          ? _c("div", [
                                              _c("div", [
                                                _c("span", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "$" +
                                                        _vm._s(_vm.donation) +
                                                        " donation"
                                                    )
                                                  ])
                                                ])
                                              ]),
                                              _c("div", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.donation,
                                                      expression: "donation",
                                                      modifiers: {
                                                        number: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass:
                                                    "slider is-fullwidth is-success",
                                                  attrs: {
                                                    step: "1",
                                                    min:
                                                      _vm.event.donationDetails
                                                        .minPrice,
                                                    max:
                                                      _vm.event.donationDetails
                                                        .maxPrice,
                                                    type: "range"
                                                  },
                                                  domProps: {
                                                    value: _vm.donation
                                                  },
                                                  on: {
                                                    __r: function($event) {
                                                      _vm.donation = _vm._n(
                                                        $event.target.value
                                                      )
                                                    },
                                                    blur: function($event) {
                                                      return _vm.$forceUpdate()
                                                    }
                                                  }
                                                })
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "level is-mobile"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "level-left"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " $" +
                                                          _vm._s(
                                                            _vm.event
                                                              .donationDetails
                                                              .minPrice
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "level-right"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " $" +
                                                          _vm._s(
                                                            _vm.event
                                                              .donationDetails
                                                              .maxPrice
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.event.festivalDonation
                                  ? _c(
                                      "div",
                                      { staticClass: "donatio pricetier" },
                                      [
                                        _c("h4", [_vm._v("Festival Donation")]),
                                        _c(
                                          "p",
                                          { staticClass: "tier-description" },
                                          [
                                            _vm._v(
                                              " Add a donation to the Twin Cities Horror Festival. "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "control donations" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.donation,
                                                      expression: "donation",
                                                      modifiers: {
                                                        number: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "is-checkradio",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "donationfive",
                                                    name: "donation",
                                                    value: "5"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.donation,
                                                      _vm._n("5")
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.donation = _vm._n("5")
                                                    }
                                                  }
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "donationfive"
                                                    }
                                                  },
                                                  [_vm._v("$5")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.donation,
                                                      expression: "donation",
                                                      modifiers: {
                                                        number: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "is-checkradio",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "donationten",
                                                    name: "donation",
                                                    value: "10"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.donation,
                                                      _vm._n("10")
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.donation = _vm._n(
                                                        "10"
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "donationten"
                                                    }
                                                  },
                                                  [_vm._v("$10")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.donation,
                                                      expression: "donation",
                                                      modifiers: {
                                                        number: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "is-checkradio",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "donationfifteen",
                                                    name: "donation",
                                                    value: "15"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.donation,
                                                      _vm._n("15")
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.donation = _vm._n(
                                                        "15"
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "donationfifteen"
                                                    }
                                                  },
                                                  [_vm._v("$15")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.donation,
                                                      expression: "donation",
                                                      modifiers: {
                                                        number: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "is-checkradio",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "donationtwenty",
                                                    name: "donation",
                                                    value: "20"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.donation,
                                                      _vm._n("20")
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.donation = _vm._n(
                                                        "20"
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "donationtwenty"
                                                    }
                                                  },
                                                  [_vm._v("$20")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.number",
                                                      value: _vm.donation,
                                                      expression: "donation",
                                                      modifiers: {
                                                        number: true
                                                      }
                                                    }
                                                  ],
                                                  staticClass: "is-checkradio",
                                                  attrs: {
                                                    type: "radio",
                                                    id: "donationtwentyfive",
                                                    name: "donation",
                                                    value: "25"
                                                  },
                                                  domProps: {
                                                    checked: _vm._q(
                                                      _vm.donation,
                                                      _vm._n("25")
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      _vm.donation = _vm._n(
                                                        "25"
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for: "donationtwentyfive"
                                                    }
                                                  },
                                                  [_vm._v("$25")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "expand" }),
                        _c(
                          "div",
                          {
                            staticClass: "columns mobilepad",
                            staticStyle: { "margin-bottom": "15px" }
                          },
                          [
                            _vm._m(0),
                            _c(
                              "div",
                              { staticClass: "is-hidden-mobile column" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-pulled-right",
                                    attrs: {
                                      disabled:
                                        _vm.eventDates > 1 && !_vm.selectedDate
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addToCart()
                                      }
                                    }
                                  },
                                  [_vm._v(" Add to Cart ")]
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "is-hidden-tablet column" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "button is-fullwidth",
                                    attrs: {
                                      disabled:
                                        _vm.eventDates > 1 && !_vm.selectedDate
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addToCart()
                                      }
                                    }
                                  },
                                  [_vm._v(" Add to Cart ")]
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.checkout
                  ? _c("div", [
                      _c("div", { staticClass: "checkout-header columns" }, [
                        _c("div", { staticClass: "column is-narrow" }, [
                          _c(
                            "span",
                            {
                              staticClass: "icon is-large",
                              on: {
                                click: function($event) {
                                  _vm.checkout = false
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-2x fa-chevron-left"
                              })
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "column has-text-centered" }, [
                          _c("h3", { staticClass: ".has-text-centered" }, [
                            _vm._v("Checkout")
                          ]),
                          _c("p", [
                            _vm._v("Time Left " + _vm._s(_vm.timeRemaining))
                          ])
                        ])
                      ]),
                      _c("hr"),
                      _c("h3", [_vm._v("Contact information")]),
                      false
                        ? _c("p", [
                            _vm._v(
                              " Continue as a guest or sign in for a faster experience "
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("First Name")
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _vm.profile && _vm.profile.firstName
                                ? _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      disabled: "true",
                                      placeholder: "Email"
                                    },
                                    domProps: { value: _vm.profile.firstName }
                                  })
                                : _vm._e(),
                              !_vm.profile || !_vm.profile.firstName
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.firstName,
                                        expression: "firstName"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "First Name"
                                    },
                                    domProps: { value: _vm.firstName },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.firstName = $event.target.value
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Last Name")
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _vm.profile && _vm.profile.lastName
                                ? _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      disabled: "true",
                                      placeholder: "Email"
                                    },
                                    domProps: { value: _vm.profile.lastName }
                                  })
                                : _vm._e(),
                              !_vm.profile || !_vm.profile.lastName
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.lastName,
                                        expression: "lastName"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Last Name"
                                    },
                                    domProps: { value: _vm.lastName },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.lastName = $event.target.value
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Email")
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _vm.profile && _vm.profile.email
                                ? _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      disabled: "true",
                                      placeholder: "Email"
                                    },
                                    domProps: { value: _vm.profile.email }
                                  })
                                : _vm._e(),
                              !_vm.profile || !_vm.profile.email
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.email,
                                        expression: "email"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Email"
                                    },
                                    domProps: { value: _vm.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.email = $event.target.value
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", { staticClass: "label" }, [
                              _vm._v("Confirm Email")
                            ]),
                            _c("div", { staticClass: "control" }, [
                              _vm.profile && _vm.profile.email
                                ? _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      disabled: "true",
                                      placeholder: "Email"
                                    },
                                    domProps: { value: _vm.profile.email }
                                  })
                                : _vm._e(),
                              !_vm.profile || !_vm.profile.email
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.confirmEmail,
                                        expression: "confirmEmail"
                                      }
                                    ],
                                    staticClass: "input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Confirm Email"
                                    },
                                    domProps: { value: _vm.confirmEmail },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) return
                                        _vm.confirmEmail = $event.target.value
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]),
                      _vm.summary.discountCode ||
                      (_vm.summary.total > 0 && _vm.event.hasDiscounts)
                        ? _c("div", [
                            _c("hr"),
                            _c("h3", [_vm._v("Discount Code")]),
                            !_vm.summary.discountCode
                              ? _c("div", { staticClass: "field" }, [
                                  _c("label", { staticClass: "label" }, [
                                    _vm._v("Enter Discount Code, if applicable")
                                  ]),
                                  _c("div", { staticClass: "control" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.discountCode,
                                          expression: "discountCode"
                                        }
                                      ],
                                      staticClass: "input",
                                      staticStyle: {
                                        "text-transform": "uppercase"
                                      },
                                      attrs: {
                                        type: "text",
                                        placeholder: "Discount Code"
                                      },
                                      domProps: { value: _vm.discountCode },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.discountCode = $event.target.value
                                        }
                                      }
                                    })
                                  ])
                                ])
                              : _vm._e(),
                            this.discountError
                              ? _c("p", { staticClass: "help is-danger" }, [
                                  _vm._v(" " + _vm._s(this.discountError) + " ")
                                ])
                              : _vm._e(),
                            _vm.summary.discountCode
                              ? _c("p", [
                                  _vm._v(" Discount code "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.summary.discountCode))
                                  ]),
                                  _vm._v(" applied. ")
                                ])
                              : _vm._e(),
                            !_vm.summary.discountCode
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "button",
                                    attrs: { disabled: _vm.discountCode == "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.applyDiscount()
                                      }
                                    }
                                  },
                                  [_vm._v(" Apply Code ")]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm.inProgressPaid || _vm.summary.total > 0
                        ? _c("div", [
                            _c("hr"),
                            _c("h3", [
                              _vm._v(" Payment Information "),
                              _vm.isPreview
                                ? _c(
                                    "span",
                                    { staticClass: "test-card-tooltip" },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-info-circle"
                                      }),
                                      _vm._m(1)
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._m(2)
                          ])
                        : _vm._e(),
                      _c("hr"),
                      _c("div", { staticClass: "optin" }, [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.optin,
                                expression: "optin"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.optin)
                                ? _vm._i(_vm.optin, null) > -1
                                : _vm.optin
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.optin,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.optin = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.optin = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.optin = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" Please add me to the artist’s mailing list")
                        ])
                      ]),
                      _vm.event.ownerType && _vm.event.ownerType == "venue"
                        ? _c("div", { staticClass: "optin" }, [
                            _c("label", { staticClass: "checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.optinVenue,
                                    expression: "optinVenue"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.optinVenue)
                                    ? _vm._i(_vm.optinVenue, null) > -1
                                    : _vm.optinVenue
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.optinVenue,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.optinVenue = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.optinVenue = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.optinVenue = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                " Please let me know about other events at " +
                                  _vm._s(_vm.event.venueName)
                              )
                            ])
                          ])
                        : _vm._e(),
                      _c("p", { staticClass: "legal" }, [
                        _vm._v(
                          " By clicking “Place Order”, I accept the Terms of Service and have read the Privacy Policy. I agree that Gobo may share my information with the event organizer. "
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                staticClass: "column is-one-third modal-right",
                class: { "is-hidden-mobile": !_vm.cart },
                attrs: { id: "ordersummary" }
              },
              [
                _c("div", [
                  _c(
                    "a",
                    {
                      staticClass: "is-hidden-mobile",
                      attrs: { id: "modalclose" },
                      on: {
                        click: function($event) {
                          return _vm.canceled()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ]),
                _c("h4", { staticClass: "ordersummary" }, [
                  _vm._v("Order Summary")
                ]),
                _vm.cartExpired
                  ? _c("p", { staticClass: "is-family-primary" }, [
                      _vm._v(
                        " Your cart has timed out and your tickets have been released back into the wild. "
                      )
                    ])
                  : _vm._e(),
                _vm.lineItems.length == 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "empty-cart is-flex is-flex-wrap-wrap is-align-content-center is-justify-content-center is-flex-grow-1"
                      },
                      [_vm._m(3)]
                    )
                  : _vm._e(),
                _vm.summary.total != null
                  ? _c(
                      "div",
                      { staticClass: "cart-summary" },
                      [
                        _vm._l(_vm.lineItems, function(item, key) {
                          return _c(
                            "div",
                            {
                              key: key,
                              staticClass: "columns is-mobile cart-line"
                            },
                            [
                              _c("div", { staticClass: "column" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.moment(item.date).format("M/D")
                                    ) + ":"
                                  )
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(item.quantity) +
                                    " " +
                                    _vm._s(item.description)
                                ),
                                _c("br"),
                                _vm._v("      " + _vm._s(item.eventTitle) + " ")
                              ]),
                              item.total != 0 && !item.discount
                                ? _c(
                                    "div",
                                    { staticClass: "column is-narrow" },
                                    [
                                      _vm._v(
                                        " $" +
                                          _vm._s(
                                            _vm.formatCurrency(item.total)
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              item.total != 0 &&
                              item.discount &&
                              item.originalPrice
                                ? _c(
                                    "div",
                                    { staticClass: "column is-narrow" },
                                    [
                                      _vm._v(
                                        " $" +
                                          _vm._s(
                                            _vm.formatCurrency(
                                              item.originalPrice
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              item.total == 0
                                ? _c(
                                    "div",
                                    { staticClass: "column is-narrow" },
                                    [_vm._v("FREE!")]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "column is-narrow trash" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "icon",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeLineItem(key)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-trash" })]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm.summary.donation
                          ? _c(
                              "div",
                              { staticClass: "columns is-mobile cart-line" },
                              [
                                _c("div", { staticClass: "column" }, [
                                  _vm._v("Donation")
                                ]),
                                _c("div", { staticClass: "column is-narrow" }, [
                                  _vm._v(
                                    " $" +
                                      _vm._s(
                                        _vm.formatCurrency(_vm.summary.donation)
                                      ) +
                                      " "
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "column is-narrow trash" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "icon",
                                        on: {
                                          click: function($event) {
                                            return _vm.removeDonation()
                                          }
                                        }
                                      },
                                      [_c("i", { staticClass: "fa fa-trash" })]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _c("hr"),
                        _c(
                          "div",
                          {
                            staticClass: "columns is-mobile subtotal cart-line"
                          },
                          [
                            _c("div", { staticClass: "column" }, [
                              _vm._v("Subtotal")
                            ]),
                            _vm.summary.subtotal != 0
                              ? _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    _vm.summary &&
                                    _vm.summary.subtotal &&
                                    !_vm.summary.discount
                                      ? _c("span", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                _vm.formatCurrency(
                                                  _vm.summary.subtotal
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm.summary &&
                                    _vm.summary.subtotal &&
                                    _vm.summary.discount
                                      ? _c("span", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                _vm.formatCurrency(
                                                  _vm.summary.subtotal +
                                                    _vm.summary.discount
                                                )
                                              )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm.summary.subtotal == 0
                              ? _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [_vm._v(" FREE! ")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm.summary.discount
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "columns is-mobile subtotal cart-line discount"
                              },
                              [
                                _c("div", { staticClass: "column" }, [
                                  _vm._v("Total Discount")
                                ]),
                                _vm.summary.total != 0
                                  ? _c(
                                      "div",
                                      { staticClass: "column has-text-right" },
                                      [
                                        _vm._v(
                                          " -$" +
                                            _vm._s(
                                              _vm.formatCurrency(
                                                _vm.summary.discount
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm.passes
                          ? _c(
                              "div",
                              _vm._l(_vm.summary.passes, function(pass) {
                                return _c(
                                  "div",
                                  {
                                    key: pass.id,
                                    staticClass:
                                      "columns is-mobile subtotal cart-line discount"
                                  },
                                  [
                                    _c("div", { staticClass: "column" }, [
                                      _vm._v(_vm._s(pass.passname))
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "column has-text-right" },
                                      [
                                        _vm._v(
                                          " -$" +
                                            _vm._s(
                                              _vm.formatCurrency(pass.discount)
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._m(4),
                        _vm.event.chargeSalesTax
                          ? _c("div", { staticClass: "columns cart-line" }, [
                              _c("div", { staticClass: "column" }, [
                                _vm._v("Sales Tax")
                              ]),
                              _c(
                                "div",
                                { staticClass: "column has-text-right" },
                                [_vm._v("$" + _vm._s(_vm.summary.salesTax))]
                              )
                            ])
                          : _vm._e(),
                        _c("hr"),
                        _c(
                          "div",
                          { staticClass: "columns is-mobile cart-total" },
                          [
                            _c("div", { staticClass: "column" }, [
                              _vm._v("Total")
                            ]),
                            _vm.summary.total != 0
                              ? _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [
                                    _vm._v(
                                      " $" +
                                        _vm._s(
                                          _vm.formatCurrency(_vm.summary.total)
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.summary.total == 0
                              ? _c(
                                  "div",
                                  { staticClass: "column has-text-right" },
                                  [_vm._v(" FREE! ")]
                                )
                              : _vm._e()
                          ]
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                !_vm.checkout
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-primary",
                        attrs: { disabled: _vm.lineItems.length < 1 },
                        on: {
                          click: function($event) {
                            return _vm.checkOut()
                          }
                        }
                      },
                      [_vm._v(" Checkout ")]
                    )
                  : _vm._e(),
                _vm.checkout
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-primary is-fullwidth",
                        class: { "is-loading": _vm.inProgress },
                        attrs: { disabled: !_vm.orderReady },
                        on: { click: _vm.placeOrder }
                      },
                      [_vm._v(" Place Order ")]
                    )
                  : _vm._e(),
                _vm.inProgress
                  ? _c("p", [
                      _vm._v(
                        " Placing order: please be patient, this may take a few seconds. "
                      )
                    ])
                  : _vm._e(),
                _vm.inProgress
                  ? _c("p", [
                      _vm._v(
                        " Step " +
                          _vm._s(_vm.orderProgress) +
                          " of 3: " +
                          _vm._s(_vm.orderStatus) +
                          " "
                      )
                    ])
                  : _vm._e(),
                _vm.errorMessage
                  ? _c("p", { staticClass: "error" }, [
                      _vm._v("Error: " + _vm._s(_vm.errorMessage))
                    ])
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e(),
    _vm.orderComplete
      ? _c("div", { attrs: { id: "complete" } }, [
          _c(
            "a",
            {
              attrs: { id: "modalclose" },
              on: {
                click: function($event) {
                  return _vm.canceled()
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          ),
          _c("div", { staticClass: "confirmation-message" }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column is-one-fifth" }),
              _c("div", { staticClass: "column" }, [
                _c("h2", [
                  _vm._v(
                    "Thanks for supporting live " +
                      _vm._s(_vm.event.genre) +
                      "!"
                  )
                ]),
                _c("p", [_vm._v("Your order is complete!")]),
                _c("div", { staticClass: "columns event-preview" }, [
                  _c("div", { staticClass: "column is-one-third" }, [
                    _c("img", {
                      staticClass: "event-image",
                      attrs: { src: _vm.event.image, alt: "event.title" }
                    })
                  ]),
                  _c(
                    "div",
                    { staticClass: "column" },
                    [
                      _vm._l(_vm.lineItems, function(item) {
                        return _c(
                          "div",
                          { key: item.row, staticClass: "timeline" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.moment(item.date).format("dddd MMM Do")
                                ) + ":"
                              )
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(item.quantity) +
                                " " +
                                _vm._s(item.description) +
                                " "
                            )
                          ]
                        )
                      }),
                      _c("h3", [_vm._v(_vm._s(_vm.event.title))]),
                      _vm.venue
                        ? _c("p", { staticClass: "venue" }, [
                            _vm._v(_vm._s(_vm.venue.name))
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]),
              _c("div", { staticClass: "column is-one-fifth" })
            ]),
            _c("div", { staticClass: "expand" }),
            _vm._m(5)
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column", attrs: { id: "poweredby" } }, [
      _c("img", { attrs: { src: "/img/powered-by-gobo2.svg", alt: "gobo" } })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tooltip-content" }, [
      _c("strong", [_vm._v("To test transactions, use these card numbers:")]),
      _c("code", [_vm._v("4242 4242 4242 4242")]),
      _vm._v(" - Success"),
      _c("br"),
      _c("code", [_vm._v("4000 0000 0000 9995")]),
      _vm._v(" - Declined"),
      _c("br"),
      _vm._v(" Use any future expiry, any 3-digit CVC, any postal code. ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("form", { attrs: { id: "payment-form" } }, [
      _c("div", { attrs: { id: "card-element" } }),
      _c("div", { attrs: { id: "card-errors", role: "alert" } })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", { attrs: { src: "/img/cart.png", alt: "cart" } })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns cart-line" }, [
      _c("div", { staticClass: "column" }, [_vm._v("Never any fees!")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "confirmation-footer" }, [
      _c("img", { attrs: { src: "/img/powered-by-gobo-white.svg", alt: "" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }